// extracted by mini-css-extract-plugin
export default {"root":"TrendIndicator_root__coxS4","positive":"TrendIndicator_positive__nsO8C","negative":"TrendIndicator_negative__ml7pa","neutral":"TrendIndicator_neutral__psoLJ"};